import { render, staticRenderFns } from "./AppUpdates.vue?vue&type=template&id=a8aab8d0"
import script from "./AppUpdates.vue?vue&type=script&lang=js"
export * from "./AppUpdates.vue?vue&type=script&lang=js"
import style0 from "./AppUpdates.vue?vue&type=style&index=0&id=a8aab8d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports